// extracted by mini-css-extract-plugin
export default {"icon":"styles-module__icon__src-labstep-web-core-Form-ShowEdit-Link-_y1dsn","customShow":"styles-module__customShow__src-labstep-web-core-Form-ShowEdit-Link-_rzsOK"};